import store from "../store";

export function updateCards(cards: any[]) {
  store.dispatch({
    type: "updateCards",
    payload: cards,
  });
}

export function setMdmCurrentStep(step: number) {
  store.dispatch({
    type: "setMdmCurrentStep",
    payload: step,
  });
}

export function setSelectedCardId(cardId: string | null) { 
  store.dispatch({
    type: "setSelectedCardId",
    payload: cardId,
  });
}
export function setMdmCurrentEntity(entity: any) {
  store.dispatch({
    type: "setMdmCurrentEntity",
    payload: entity,
  });
}

export function setFormConfig(formConfig: any) {
  store.dispatch({
    type: "setFormConfig",
    payload: formConfig,
  });
}